import _toConsumableArray from "/codebuild/output/src1081057209/src/api-desk/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//import _ from 'lodash'  // does not work in browser
// FUTURE FIX: https://2ality.com/2017/01/import-operator.html
var _lodash = null; // HACK: lodash loader...

if (typeof _ === 'undefined') {
  import('lodash').then(function (ld) {
    _lodash = ld;
  });
}

import { is_empty_str, simple_deep_equal } from './utils.js';
import { guess_alignments } from './guesser.js';
import { convert_profile_description_to_tagexp, convert_profile_extra, convert_profile_query_ored_tag_regexps } from './convert.js'; //import { type } from 'os'

export function ignore_for_internal_apikp_use_only(_ref) {
  var au = _ref.au;
  // remove apis with for_internal_apikp_use_only = true
  var apis = au.apis.filter(function (a) {
    return a.for_internal_apikp_use_only === null;
  });
  var result = null;
  au.feeds.forEach(function (f) {
    // remove viewspecs with for_internal_apikp_use_only feeds
    if (!f.for_internal_apikp_use_only) {
      // find viewspec via f.viewspec_id
      var vspecs = au.viewspecs || [];
      var viewspec = vspecs.find(function (vs) {
        return f.viewspec_id === vs.id;
      });

      if (!result) {
        result = {
          feeds: [f],
          viewspecs: viewspec ? [viewspec] : []
        };
      } else {
        result.feeds.push(f); // only push viewspec if not yet in array

        var index = result.viewspecs.findIndex(function (vs) {
          return vs.id === f.viewspec_id;
        });

        if (index === -1 && viewspec) {
          result.viewspecs.push(viewspec);
        }
      }
    }
  });

  if (result) {
    // Overwrite apis/feeds/viewspecs with less data - no for_internal_apikp_use_only entries
    au.apis = apis;
    au.feeds = result.feeds;
    au.viewspecs = result.viewspecs;
  }

  return au;
}
export function check_consistency_of_feed_definition_and_feeds(_ref2) {
  var fdef = _ref2.fdef,
      au = _ref2.au,
      profiles = _ref2.profiles;
  var feed_definitions = fdef.feed_definitions;
  var fd = feed_definitions[0];
  var alignments = fd.alignments;
  var feeds = au.feeds;
  var result = null;
  feeds.forEach(function (f) {
    // Check nicknames - ignore internal apis
    if (!f.for_internal_apikp_use_only && f.nickname !== fd.nickname) {
      var output = 'Invalid nickname: ' + f.nickname;
      console.log(output);

      if (!result) {
        result = {
          result: false,
          reasons: [output]
        };
      } else {
        result.reasons.push(output);
      }
    } // Check sales_description - ignore internal apis


    var f_sales_description = f.sales_description ? f.sales_description : f.sales_description === null || f.sales_description === undefined ? undefined : '';

    if (!f.for_internal_apikp_use_only && f_sales_description !== fd.sales_description) {
      var _output = 'Invalid sales_description: ' + f_sales_description;

      console.log(_output);

      if (!result) {
        result = {
          result: false,
          reasons: [_output]
        };
      } else {
        result.reasons.push(_output);
      }
    } // Check apis


    var fd_apis = fd.api;
    var found_api_kind = fd_apis.find(function (a) {
      return a.api_kind === f.api_kind;
    });

    if (!f.for_internal_apikp_use_only && found_api_kind === undefined) {
      var _output2 = 'Invalid api_kind: ' + f.api_kind;

      console.log(_output2);

      if (!result) {
        result = {
          result: false,
          reasons: [_output2]
        };
      } else {
        result.reasons.push(_output2);
      }
    } // Check valid_from/valid_to


    var valid_from = fd.valid_from;
    valid_from = is_empty_str(valid_from) ? ' ' : valid_from; // Consider not yet defined at all (old aufschaltung)

    var feed_valid_from = f.valid_from ? f.valid_from : f.valid_from === undefined ? undefined : ' ';

    if (!f.for_internal_apikp_use_only && valid_from !== feed_valid_from) {
      var _output3 = 'Invalid valid_from: ' + valid_from + ' ' + feed_valid_from;

      console.log(_output3);

      if (!result) {
        result = {
          result: false,
          reasons: [_output3]
        };
      } else {
        result.reasons.push(_output3);
      }
    }

    var valid_to = fd.valid_to;
    valid_to = is_empty_str(valid_to) ? ' ' : valid_to; // Consider not yet defined at all (old aufschaltung)

    var feed_valid_to = f.valid_to ? f.valid_to : f.valid_to === undefined ? undefined : ' ';

    if (!f.for_internal_apikp_use_only && valid_to !== feed_valid_to) {
      var _output4 = 'Invalid valid_to: ' + valid_to + ' ' + feed_valid_to;

      console.log(_output4);

      if (!result) {
        result = {
          result: false,
          reasons: [_output4]
        };
      } else {
        result.reasons.push(_output4);
      }
    } // profile


    var fd_profiles = fd.profile;
    var query_ored_tag_regexps = [];
    profiles.forEach(function (p) {
      if (f.profile_id === p.id) {
        query_ored_tag_regexps.push.apply(query_ored_tag_regexps, _toConsumableArray(p.query_ored_tag_regexps));
      }
    });
    var tags = fd_profiles.find(function (p, i) {
      return convert_profile_description_to_tagexp(p) === query_ored_tag_regexps[i];
    });

    if (!f.for_internal_apikp_use_only && tags === undefined) {
      var _output5 = 'Invalid query_ored_tag_regexps: ' + query_ored_tag_regexps;

      console.log(_output5);

      if (!result) {
        result = {
          result: false,
          reasons: [_output5]
        };
      } else {
        result.reasons.push(_output5);
      }
    } // image


    var images = fd.image;
    var viewspec_id = f.viewspec_id; // Skip test for old aufschaltungen

    if (!f.for_internal_apikp_use_only && viewspec_id) {
      var vspec = get_viewspec({
        viewspec_id: viewspec_id,
        au: au
      });
      var media_group_content_opts = vspec ? vspec.media_group_contents_options : {};

      if (!compare_fdef_with_feed_images(images, media_group_content_opts)) {
        var _output6 = 'Invalid images: ' + images + ' ' + media_group_content_opts;

        console.log(_output6);

        if (!result) {
          result = {
            result: false,
            reasons: [_output6]
          };
        } else {
          result.reasons.push(_output6);
        }
      }
    } // format


    var format = fd.format; // Skip test for old aufschaltungen

    if (!f.for_internal_apikp_use_only && viewspec_id) {
      var _vspec = get_viewspec({
        viewspec_id: viewspec_id,
        au: au
      });

      var feed_options = _vspec ? _vspec.feed_options : {};

      if (!compare_fdef_with_feed_format(format, feed_options)) {
        var _output7 = 'Invalid format: ' + JSON.stringify(format) + ' ' + JSON.stringify(feed_options);

        console.log(_output7);

        if (!result) {
          result = {
            result: false,
            reasons: [_output7]
          };
        } else {
          result.reasons.push(_output7);
        }
      }
    } // feed_id, version must match corresponding values in alignments


    if (alignments) {
      var checked_alignments = check_consistency_of_alignments_and_feeds({
        alignments: alignments,
        feeds: feeds
      });

      if (!checked_alignments.result) {
        if (!result) {
          result = {
            result: checked_alignments.result,
            reasons: checked_alignments.reasons
          };
        } else {
          var _result$reasons;

          (_result$reasons = result.reasons).push.apply(_result$reasons, _toConsumableArray(checked_alignments.reasons));
        }
      }
    }
  }); // extra - 'one_day_ago' - 'timewindow'/'timewindowunit' - 'provider'

  var extras = fd.extra;
  var query_extra = profiles[0].query_extra || '';
  query_extra = query_extra.trim(); // Get rid of empty spaces

  var has_extra = extras && extras.length > 0 ? true : false;
  var has_query_extra = query_extra && query_extra.length > 0 ? true : false; // Check whether extras need to be checked

  if (has_extra || has_query_extra) {
    var invalid_extras = false;

    if (query_extra && query_extra.length > 0) {
      query_extra = query_extra ? JSON.parse(query_extra) : null;
      var extra = extras[0];

      if (simple_deep_equal(extra, {
        one_day_ago: true
      })) {
        // one_day_ago
        var expected = {
          range: {
            version_created: {
              to: 'now-1d/m'
            }
          }
        };

        if (!simple_deep_equal(expected, query_extra)) {
          invalid_extras = true;
        }
      }

      if (extra.timewindow && extra.timewindowunit && ['h', 'd'].find(function (u) {
        return extra.timewindowunit === u;
      })) {
        var _expected = {
          range: {
            version_created: {
              from: "now-".concat(extra.timewindow).concat(extra.timewindowunit, "/h")
            }
          }
        };

        if (!simple_deep_equal(_expected, query_extra)) {
          invalid_extras = true;
        }
      }

      if (extra.provider) {
        var _expected2 = {
          term: {
            tags: extra.provider
          }
        };

        if (!simple_deep_equal(_expected2, query_extra)) {
          invalid_extras = true;
        }
      }
    } else {
      // More than one element not allowed
      invalid_extras = true;
    }

    if (invalid_extras) {
      var output = 'Invalid extras: ' + extras;

      if (!result) {
        result = {
          result: false,
          reasons: output
        };
      } else {
        result.reasons.push(output);
      }
    }
  }

  return result ? result : {
    result: true,
    reasons: []
  };
}
export function check_consistency_of_alignments_and_feeds(_ref3) {
  var alignments = _ref3.alignments,
      feeds = _ref3.feeds;
  var result = null;
  feeds.forEach(function (f) {
    var matches = alignments.find(function (a) {
      return a.feed_id === f.id && a.api_kind === f.api_kind;
    });

    if (!f.for_internal_apikp_use_only && matches === undefined) {
      var output = 'Invalid alignments: ' + JSON.stringify(alignments);
      console.log(output);

      if (!result) {
        result = {
          result: false,
          reasons: [output]
        };
      } else {
        result.reasons.push(output);
      }
    }
  });
  return result ? result : {
    result: true,
    reasons: []
  };
}
export function get_alignments_from_au(_ref4) {
  var au = _ref4.au;
  if (!au) return [];
  var feed_definitions = au.feed_definitions ? au.feed_definitions : [];
  var fdef = feed_definitions.length ? feed_definitions[0] : null; //const alignments = fdef && fdef.alignments ? JSON.parse(JSON.stringify(fdef.alignments)) : guess_alignments(au.feeds)

  var alignments = fdef && fdef.alignments ? _lodash ? _lodash.cloneDeep(fdef.alignments) : _.cloneDeep(fdef.alignments) : guess_alignments(au.feeds);
  return alignments;
}
export function default_feed_definition(default_profile) {
  var today = new Date().toISOString().substr(0, 10);
  return {
    "feed_definitions": [{
      "nickname": default_profile.nickname,
      "sales_description": default_profile.sales_description,
      "profile": default_profile.profile,
      "extra": default_profile.extra,
      "image": [],
      "format": [{
        "formatname": "digitalwires",
        "from": ">=0.0.1",
        "to": "<2.0.0"
      }],
      "api": [{
        "api_kind": "s3push"
      }, {
        "api_kind": "wireq"
      }],
      "valid_from": today,
      "valid_to": " ",
      "alignments": []
    }]
  };
}

function get_viewspec(_ref5) {
  var viewspec_id = _ref5.viewspec_id,
      au = _ref5.au;

  if (!viewspec_id || !au) {
    return null;
  }

  var viewspecs = au.viewspecs || [];
  var viewspec = viewspecs.find(function (vs) {
    return vs.id === viewspec_id;
  });
  return viewspec ? viewspec : null;
}

export function compare_fdef_with_feed_images(fdef_image, media_group_content_opts) {
  /** Helper function which returns whether the images of a feed_definition
  match the image definition of a viewspec.
  */
  var feed_images = media_group_content_opts ? media_group_content_opts.image_sizes : [];
  feed_images = feed_images ? feed_images : []; // convert feed images into comparable format

  feed_images = feed_images.map(function (img_entry) {
    if (typeof img_entry === 'number') {
      return {
        size: img_entry.toString(),
        width: '',
        height: ''
      };
    } else {
      if (img_entry.length === 2 && typeof img_entry[0] === 'number' && typeof img_entry[1] === 'number') {
        return {
          size: '',
          width: img_entry[0].toString(),
          height: img_entry[1].toString()
        };
      } else return {};
    }
  });
  var diff = _lodash ? _lodash.differenceWith(fdef_image, feed_images, _lodash.isEqual) : _.differenceWith(fdef_image, feed_images, _.isEqual);
  return diff.length ? false : true;
}
export function compare_fdef_with_feed_format(fdef_format, feed_options) {
  /** Helper function which returns whether the format of a feed_definition
  match the format definition of a viewspec.
  */
  // Only allow one format
  if (fdef_format.length !== 1 || feed_options.required_format === undefined) return false;
  var single_fdef_format = fdef_format[0];
  var same_format = single_fdef_format.formatname === feed_options.required_format;
  var same_from = single_fdef_format.from === feed_options.required_format_version[0];
  var same_to = single_fdef_format.to === feed_options.required_format_version[1];
  return same_format && same_from && same_to;
}
export function fdef_matches_profile_group(_ref6) {
  var group_feeds = _ref6.group_feeds,
      group_profile = _ref6.group_profile,
      group_apis = _ref6.group_apis,
      group_viewspecs = _ref6.group_viewspecs,
      fdef = _ref6.fdef;

  /**
  * Returns whether given `fdef` (feed_definition) matches given profile group
  * data.
  */
  var nickname = fdef.nickname;
  var sales_description = fdef.sales_description;
  var image = fdef.image;
  var format = fdef.format;
  var valid_from = fdef.valid_from.trim();
  var valid_to = fdef.valid_to.trim(); //const alignments = fdef.alignments

  var result = true; // Match feeds - nickname, valid_from, valid_to, sales_description

  group_feeds.forEach(function (f) {
    // Ignore internal feeds
    if (!f.for_internal_apikp_use_only) {
      var f_valid_from = f.valid_from ? f.valid_from : '';
      var f_valid_to = f.valid_to ? f.valid_to : '';
      var f_sales_description = f.sales_description ? f.sales_description : f.sales_description === null || f.sales_description === undefined ? undefined : '';

      if (f.nickname !== nickname || f_sales_description !== sales_description || f_valid_from !== valid_from || f_valid_to !== valid_to) {
        result = false;
        return;
      }
    }
  }); // Match profile - nickname, query_extra, query_ored_tag_regexp

  group_profile.forEach(function (p) {
    // Remove all whitespaces of query_extra
    var conv_fdef_extra = convert_profile_extra(fdef.extra || []).replace(/\s+/g, '');

    if (p.nickname !== nickname || !simple_deep_equal(p.query_ored_tag_regexps, convert_profile_query_ored_tag_regexps(fdef.profile || [])) || p.query_extra.replace(/\s+/g, '') !== conv_fdef_extra) {
      result = false;
      return;
    }
  }); // Match apis

  group_apis.forEach(function (a) {
    // ignore internal api
    if (!a.kind === 'graphqlapikp') {
      var match_api = fdef.api.find(function (fd_api) {
        return fd_api.api_kind === a.kind;
      });

      if (match_api === undefined) {
        result = false;
        return;
      }
    }
  }); // Match format/image

  group_viewspecs.forEach(function (vs) {
    // internal viewspec if no feed_options
    var is_internal = _lodash ? _lodash.isEmpty(vs.feed_options) : _.isEmpty(vs.feed_options);
    if (is_internal) return;
    var media_group_content_opts = vs.media_group_contents_options ? vs.media_group_contents_options : {};

    if (!compare_fdef_with_feed_format(format, vs.feed_options) || !compare_fdef_with_feed_images(image, media_group_content_opts)) {
      result = false;
      return;
    }
  });
  return result;
}
export function find_matching_feed_definition(_ref7) {
  var group_feeds = _ref7.group_feeds,
      group_profile = _ref7.group_profile,
      group_apis = _ref7.group_apis,
      group_viewspecs = _ref7.group_viewspecs,
      feed_definitions = _ref7.feed_definitions;

  /* Find matching feed_definition for given profile, return it and its original
  index.
  */
  var match = [];
  var origin_index;
  feed_definitions.forEach(function (fdef, index) {
    if (fdef_matches_profile_group({
      group_feeds: group_feeds,
      group_profile: group_profile,
      group_apis: group_apis,
      group_viewspecs: group_viewspecs,
      fdef: fdef
    })) {
      origin_index = index;
      match.push(fdef);
      return;
    }
  }); // no matches
  //console.log('=============================== RESULT MATCH', match.length, origin_index)

  return {
    match: match,
    origin_index: origin_index
  };
}